export const orders = {
  data: [{
    title: '高级软件工程师招聘',
    tags: '计算机科学或相关专业，本科以上学历，3年以上工作经验',
    public: "李经理",
    mobile: '139 8213 6528',
    fee: '25,000元',
    imgs: [`/img/招聘信息/1.jpg`, `/img/招聘信息/1.webp`, `/img/招聘信息/1的副本.webp`],
    description: `1、组织制定和实施重大技术决策和技术方案，制定技术发展战略、规划发展方向；
2、提出新项目开发计划，并提交项目建议书；
3、进行项目计划、工作统筹，带领技术团队完成项目开发和文档管理；
4、进行技术难题的攻关和预研；
5、实现提出的技术需求；解答客户提出的技术问题，提供技术支持；
6、拟定团队的工作目标并监督实施；
7、团队管理、指导学习、安排培训，提升团队技术水平。
`
  }, {
    title: '市场营销经理招聘',
    tags: '市场营销专业，本科以上学历，5年以上工作经验',
    public: "王总监",
    mobile: '157 8219 3045',
    fee: '20,000元',
    imgs: [`/img/招聘信息/2.jpg`, `/img/招聘信息/3fe34be4-6360-44d7-b8b6-4ade7c335a4c.png`, `/img/招聘信息/4a997458-980e-488f-9cb4-2191db12c1ab.jpg`],
    description: `岗位职责：
1、执行相关产品的市场营销活动计划，搜集客户信息和客户意见；
2、维护所负责客户的关系，完成业绩目标；
3、负责产品促销计划的执行；
`
  }, {
    title: '行政助理招聘',
    tags: '行政管理或相关专业，大专以上学历，1年以上工作经验',
    public: "赵主管",
    mobile: '182 8216 7863',
    fee: '6,000元',
    imgs: [`/img/招聘信息/3.jpg`, `/img/招聘信息/20a67027-aa4d-4813-8f7d-ac52d00320e4.jpg`, `/img/招聘信息/23e1fa62-dd94-4871-9167-272395bc3ee1.jpg`],
    description: `岗位职责：
1、起草和修改报告、文稿等；
2、及时准确的更新员工通讯录；管理公司网络、邮箱；
3、负责日常办公用品采购、发放、登记管理，办公室设备管理；
4、订阅年度报刊杂志，收发日常报刊杂志及交换邮件；
5、员工考勤系统维护、考勤统计及外出人员管理；
6、合同管理。
`
  }, {
    title: '产品经理招聘',
    tags: '工商管理或相关专业，本科以上学历，3年以上工作经验',
    public: "刘经理",
    mobile: '130 8217 1294',
    fee: '18,000元',
    imgs: [`/img/招聘信息/4.jpg`, `/img/招聘信息/23fef777-051d-41fc-b608-14095ae58001.png`, `/img/招聘信息/38c1c7ee-4387-43da-b91a-a493fd8467f2.png`],
    description: `岗位职责：
1、负责策划/设计新产品；
2、负责新产品的创新和预研，完成新产品的用户需求定义、产品功能/UI/交互的设计；
3、负责制定项目开发计划并跟踪进度，确保项目如期完成；
4、负责项目资源的协调与组织，确保项目团队各关系人协同工作；
`
  }, {
    title: '财务经理招聘',
    tags: '财务管理或相关专业，本科以上学历，5年以上工作经验',
    public: "陈总监",
    mobile: '131 8218 5630',
    fee: '22,000元',
    imgs: [`/img/招聘信息/5.jpg`, `/img/招聘信息/截屏2024-08-20 15.30.09.png`, `/img/招聘信息/截屏2024-08-20 15.30.19.png`],
    description: `岗位职责:有意向求职者可直接电话联系
1、日常财务核算、会计凭证、出纳、税务工作的审核;
2、研究制定会计政策和操作指导，调整会计准则;
3、审核公司财务报表、核对关联往来，合并报表并进行财务分析;
4、提供财务月报、季报和年报:
5、组织业务学习、培训和会计岗位技能训练;
`
  }, {
    title: 'UI设计师招聘',
    tags: '设计相关专业，本科以上学历，2年以上工作经验',
    public: "孙主管",
    mobile: '156 8214 9071',
    fee: '15,000元',
    imgs: [`/img/招聘信息/6.jpg`, `/img/招聘信息/截屏2024-08-20 15.30.25.png`, `/img/招聘信息/截屏2024-08-20 15.30.33.png`],
    description: `【任职要求】
- 精通色彩理论、布局和排版，具备优秀的审美能力和创新思维。
- 能够独立完成项目，同时具备良好的团队协作精神。
- 具备良好的沟通能力，能够清晰表达设计理念和设计决策。
`
  }, {
    title: '人力资源经理招聘',
    tags: '人力资源管理或相关专业，本科以上学历，5年以上工作经验',
    public: "周经理",
    mobile: '133 8215 2486',
    fee: '20,000元',
    imgs: [`/img/招聘信息/7.jpg`, `/img/招聘信息/截屏2024-08-20 15.30.43.png`, `/img/招聘信息/截屏2024-08-20 15.32.52.png`],
    description: `岗位职责：
1、在公司人力资源战略、政策和指引的框架下，建立并实施人力资源方针和行动计划，以支持公司达到预期经营目标；
2、负责组织起草、修改和完善人力资源相关管理制度和工作流程；
3、负责招聘、培训、薪酬、考核、员工关系等人力资源日常管理事宜；
4、负责组织编写各部门职位说明书；
5、定期进行人力资源数据分析，提交公司人力资源分析报告；
6、根据行业和公司发展状况，协助制定公司薪酬体系、激励体系并负责实施
`
  }, {
    title: '运营专员招聘',
    tags: '电子商务或相关专业，本科以上学历，1年以上工作经验',
    public: "吴主管",
    mobile: '153 8210 6759',
    fee: '8,000元',
    imgs: [`/img/招聘信息/8.jpg`, `/img/招聘信息/截屏2024-08-20 15.32.59.png`, `/img/招聘信息/截屏2024-08-20 15.33.07.png`],
    description: `岗位职责：
1、负责广告片的剪辑和包装设计及制作；
2、理解电视语言，根据创意脚本或文案对广告片进行制作、剪辑和编排，传达宣传诉求；
3、广告片的剪辑合成的制作。
`
  }, {
    title: '售前工程师招聘',
    tags: '通信工程或相关专业，本科以上学历，3年以上工作经验',
    public: "何经理",
    mobile: '180 8211 3842',
    fee: '14,000元',
    imgs: [`/img/招聘信息/9.jpg`, `/img/招聘信息/a02e4a25-2ff4-43bf-a203-cffb481d05c8.png`, `/img/招聘信息/c865793e-dbc5-45ae-961e-068b2a2c9b5b.jpg`],
    description: `工作内容：
1.负责公司产品的销售及推广；
2.根据市场营销计划，完成部门销售指标；
3.开拓新市场，发展新客户，增加产品销售范围；
4.负责对渠道用户进行摆点销售等销售方式。
`
  }, {
    title: '客户服务专员招聘',
    tags: '客户服务或相关专业，大专以上学历，1年以上工作经验',
    public: "韩主管",
    mobile: '138 8234 5971',
    fee: '7,000元',
    imgs: [`/img/招聘信息/10.jpg`, `/img/招聘信息/cbe2d84b-8988-496b-a6f5-7f13eed58859.jpg`, `/img/招聘信息/d7938a7b-e486-4f19-8a56-e3e02db79a44.png`],
    description: `聊天客服：6人
1.交通便利，8号线直达 20米 地铁站旁 春熙路15分钟
2.氛围轻松愉快，无勾心斗角，工作简单，就是聊天，聊天，无任务要求，
3.工作简单，在线平台与客户进行有效沟通，拥有良好的人际交往能力和耐心细致的服务态度。
`
  }, {
    title: '数据分析师招聘',
    tags: '统计学或相关专业，本科以上学历，2年以上工作经验',
    public: "陈经理",
    mobile: '139 0856 2340',
    fee: '16,000元',
    imgs: [`/img/招聘信息/11.jpg`, `/img/招聘信息/download.jpg`, `/img/招聘信息/e0407165-5b3b-4af4-99c5-8968e3eebc98.jpg`],
    description: `岗位职责：
1、验证车载软件和电子系统的各项功能是否按照预定要求正常工作。
1、检查车辆的自我诊断和故障检测能力。
3、电磁兼容性测试，确保电子设备不会由于电磁干扰影响性能或产生故障。
4、网络通信测试，测试内部网络，如CAN,LIN, FlexRay,Ethernet等的通信能力和性能。
5、安全测试，验证车载系统的安全功能，如防抱死制动系统(ABS)、电子稳定程序(ESP)等。
`
  }, {
    title: '网络安全工程师招聘',
    tags: '信息安全或相关专业，本科以上学历，3年以上工作经验',
    public: "杨主管",
    mobile: '13911658801',
    fee: '19,000元',
    imgs: [`/img/招聘信息/12.jpg`, `/img/招聘信息/download.jpg`, `/img/招聘信息/ef86cf58-31e6-4f06-9e96-bf0d9baa6e79.jpg`],
    description: `工作内容：远程管理机房设备 做好日常维护
职位要求：熟练掌握Linux系统，熟练服务器硬件装拆机，熟练交换机配置和网络搭建。
工作时间：全天
`
  }]
}